// Copied from /ui/components/wallet-snapshot/parts/fancy-amount.
// TODO: Unify with support for different colors, and sizes.

import { cn } from '@/ui/utils/classnames';

const SYMBOL = '$'; // Only USD is supported for now.
const SEPARATOR_LENGTH = 1;
const FRACTION_DIGITS_LENGTH = 2;

const formatter = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  minimumFractionDigits: FRACTION_DIGITS_LENGTH,
  maximumFractionDigits: FRACTION_DIGITS_LENGTH,
});

function formatValue(value: number | null) {
  if (value === null) {
    return {
      symbol: SYMBOL,
      integerDigits: '-',
      fractionDigits: `.${'-'.repeat(FRACTION_DIGITS_LENGTH)}`,
    };
  }

  const formattedValue = formatter.format(value);
  const [integerDigits, fractionDigits] = [
    formattedValue.slice(0, -FRACTION_DIGITS_LENGTH - SEPARATOR_LENGTH),
    formattedValue.slice(-FRACTION_DIGITS_LENGTH - SEPARATOR_LENGTH),
  ];
  return { symbol: SYMBOL, integerDigits, fractionDigits };
}

export interface FancyAmountProps {
  value: number | null;
  className?: string;
}

function FancyAmount({ value, className }: FancyAmountProps) {
  const { symbol, integerDigits, fractionDigits } = formatValue(value);

  return (
    <h1
      className={cn(
        'flex-inline items-baseline text-nowrap font-medium leading-none text-black theme-dark:text-white',
        className,
      )}
    >
      <small className="text-[24px]">{symbol}</small>{' '}
      <span className="text-[32px]">{integerDigits}</span>
      <small className="text-[24px] text-black/40 theme-dark:text-neutral-200">
        {fractionDigits}
      </small>
    </h1>
  );
}

export default FancyAmount;
